



































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Typography, Surface, TextField } from '@/components/atoms';
import { Radio } from '@/components/molecules';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import CustomersIcon from '@/components/icons/Customers.vue';
import FormHeader from '@/componentsV2/molecules/FormHeader/FormHeader.vue';

import { pluralize } from '@/utils';

@Component({
  components: {
    Typography,
    Surface,
    Radio,
    Checkbox,
    TextField,
    CustomersIcon,
    FormHeader
  }
})
export default class OfferFreeCoinsCustomerSettings extends Vue {
  @Prop({ default: 'no-limit' }) readonly value!: string;
  @Prop({ default: false }) readonly onlyNewCustomers!: boolean;
  @Prop({ default: undefined }) customerLimit!: number;
  @Prop({ default: undefined }) customerDailyLimit!: number;
  @Prop({ default: 0 }) coins!: number;
  @Prop() readonly error!: any[];
  @Prop({ default: true }) hasHeader?: boolean;

  pluralize = pluralize;

  toggleNewCustomers(flag: { id: string; state: boolean }) {
    this.$emit('toggleNewCustomers', flag.state);
  }

  changeTypeCustomer(type: string) {
    this.$emit('input', type);

    const focusMapper: Record<string, any> = {
      'total-customer': () => {
        const customerLimit = this.$refs.customerLimit as any;

        customerLimit.$refs.input.focus();
      },
      'daily-customer': () => {
        const customerDailyLimit = this.$refs.customerDailyLimit as any;

        customerDailyLimit.$refs.input.focus();
      }
    };

    if (!focusMapper[type]) return;

    focusMapper[type]();
  }

  get coinsTotal() {
    const limit = this.customerLimit || 100;
    const coinsAmount = this.coins ? limit * Number(this.coins) : 0;

    return `${coinsAmount} ${pluralize(coinsAmount, 'coin')} total`;
  }

  get coinsDailyTotal() {
    const limit = this.customerDailyLimit || 100;
    const coinsAmount = this.coins ? limit * Number(this.coins) : 0;

    return `${coinsAmount} ${pluralize(coinsAmount, 'coin')}/day max`;
  }

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get descriptionSwitch() {
    return 'If enabled, only members who haven’t claimed Welcome Coins from this campaign can claim them.';
  }

  get descriptionNoCustomerLimit() {
    return 'People will be able to claim Welcome Coins until you deactivate this campaign or it reaches a deadline.';
  }

  get descriptionTotalCustomer() {
    return 'Set the total number of members that can claim Welcome Coins.';
  }

  get descriptionDailyCustomer() {
    return 'Set a daily maximum number of members who can claim Welcome Coins.';
  }
}
